import { render, staticRenderFns } from "./ManualBulkMapping.vue?vue&type=template&id=c4971fc4"
import script from "./ManualBulkMapping.vue?vue&type=script&lang=ts"
export * from "./ManualBulkMapping.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports